import React, { useEffect } from "react";
import { Box } from "@mui/material";
import useSWRInfinite from "swr/infinite";
import { useInView } from "react-intersection-observer";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
// import useSWR from "swr";

import { setLoadNavigation } from "../../../../redux/features/settingSlice";
import LoadingCart from "../LoadingCart";
// import DetailCart from "../DetailCart";
import NewDetailCart from "../NewDetailCart";
// import EmptyState from "../../EmptyState";
import { fetcherGetToken } from "../../../../services/fetcher";

const OpinionBox = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const {
    data: opinion,
    isLoading,
    isValidating,
    size,
    setSize,
  } = useSWRInfinite(
    (pageIndex, previousPageData) => {
      if (previousPageData && !previousPageData.results.length) return null;

      return [
        `${process.env.REACT_APP_API}/content/opinions/${
          params.tableId
        }/?page=${pageIndex + 1}`,
        tokenStorage,
      ];
    },
    fetcherGetToken,
    {
      revalidateFirstPage: true,
    }
  );

  // const { data: table } = useSWR(() => {
  //   return [`${process.env.REACT_APP_API}/content/table/${params.tableId}/`, tokenStorage];
  // }, fetcherGetToken);

  useEffect(() => {
    !isLoading && dispatch(setLoadNavigation(isValidating));
  }, [dispatch, isLoading, isValidating]);

  useEffect(() => {
    inView && moreInfinite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const moreInfinite = () => {
    const moreOpinionCart = size + 1 <= (opinion && opinion[0]?.total_pages);
    if (moreOpinionCart) {
      setSize(size + 1);
      dispatch(setLoadNavigation(true));
    } else {
      // setSize(opinion[0].total_pages);
    }
  };

  const opinionsList = () => {
    let opinionList = [];
    if (opinion) {
      // eslint-disable-next-line array-callback-return
      opinion.map((e) => {
        opinionList.push(...e.results);
      });
    }
    return opinionList;
  };

  return (
    <Box>
      {/* {opinionsList().length > 0 && (
        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            marginBottom: "12px",
            color: "textField.main",
          }}
        >
          Opinions:
        </Typography>
      )} */}

      {(isLoading || !opinion) && <LoadingCart type='opinion' />}
      {opinionsList().map((row) => {
        return <NewDetailCart key={row.pk} type='opinion' rowData={row} />;
      })}
      {/* {!isLoading && opinion && opinionsList().length === 0 && (
        <EmptyState
          title='There is no opinion posted yet'
          dis={
            table?.enrolled
              ? "You can find a new table!"
              : "Enroll in this table to inform about updates! Or find a new table."
          }
          btn1='table'
          btn2={table?.enrolled ? "" : "enroll"}
        />
      )} */}
      {!isLoading && opinion && (
        <Box ref={ref} sx={{ display: "flex", justifyContent: "center" }}></Box>
      )}
    </Box>
  );
};
export default OpinionBox;
